// extracted by mini-css-extract-plugin
module.exports = {"container":"Incident_container__27Fyl","page":"Incident_page__MpiU4","section":"Incident_section__3bdin"};